import page from './page'

export default page



// WEBPACK FOOTER //
// ./src/views/register/index.js